// gloss
export const API_TOKEN_SCOPES = ['read', 'read,write', 'embed'] as const;

export type ApiTokenScope = (typeof API_TOKEN_SCOPES)[number];

// gloss
export type ApiTokenCapability = 'read' | 'write' | 'embed';

// gloss
export const API_TOKEN_SCOPE_LABELS: Record<ApiTokenScope, string> = {
  read: 'Read only',
  'read,write': 'Read & write',
  embed: 'Embed sessions (adds new members)',
};

// gloss
export const hasApiTokenCapability = (scopes: string | null | undefined, capability: ApiTokenCapability): boolean =>
  (scopes ?? '')
    .split(',')
    .map((scope) => scope.trim())
    .includes(capability);
